import { gql, useLazyQuery, useQuery } from "@apollo/client";
import { useEffect, useMemo, useState } from "react";
import { EMTAccountForReport } from "../../../Utils/AllPagesQuriesAndMutations";
import useProcessData from "../../../CommonFunction/ProcessData";
import { Loading, LoadTable } from "../../Components";
import "./Dashboard.scss";
import { useSelector } from "react-redux";
import useFetchTableData from "../../custom_hooks/useFetchTableData";

export const queryfunctionForEMTAccountFilters = (fields) => {
  const query = gql`
    query EMTAccountFilters(
  $dnd: Boolean
  $wrongCustomer: Boolean
  $kycComplete: Boolean
  $isLaneAdded: Boolean
  $isVehicleTypeAdded: Boolean
  $User_Account_Type:String="SP"
) {
  EMTAccountFilters(
    DND: $dnd
    Wrong_Customer: $wrongCustomer
    KYC_Complete: $kycComplete
    Is_LaneAdded: $isLaneAdded
    Is_VehicleTypeAdded: $isVehicleTypeAdded
    User_Account_Type:$User_Account_Type
  ) {
          _id
         
         ${fields?.join(" ")}
        }
      }
      `;
  return query;
};

const LaneAdded = () => {
  const Key = "Lane_Not_Emt_Accounts";
  let Refetch = useSelector((store) => store?.FormFieldData.refresh);
  const [formData, setFormData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const [checkedState, setCheckedState] = useState({
    dnd: false,
    wrongCustomer: false,
  });
  const [LaneNotAddedAccounts, { data, refetch, loading, error }] = useLazyQuery(
    queryfunctionForEMTAccountFilters([]),
    {
      context: {
        headers: { "X-GraphQL-Server": "secondary" },
      },
      fetchPolicy: "network-only",
      variables: {
        dnd: false,
        wrongCustomer: false,

        isLaneAdded: false,
      },
      onCompleted: () => {
        setIsLoading(false);
      },
      onError: () => {
        setIsLoading(false);
      },
    }
  );

  const config = useMemo(
    () => ({
      dataKey: "EMTAccountFilters",
      dateKeys: ["createdAt", "updatedAt"],
      deleteKeys: ["__typename"],
    }),
    []
  );

  useEffect(() => {
    if (Refetch) {
      refetch();
    }
  }, [Refetch]);
  const handleCheckboxChange = (event) => {
    // Update the state based on the checkbox that triggered the change
    setCheckedState({
      ...checkedState,
      [event.target.name]: event.target.checked,
    });

    refetch({ ...checkedState, [event.target.name]: event.target.checked });
  };
  console.log(data, "datadatadata");
  useFetchTableData(queryfunctionForEMTAccountFilters, LaneNotAddedAccounts, setIsLoading, Key);
  const { loading: processDataLoading } = useProcessData(data, setFormData, config);
  console.log(formData.length === 0);
  return (
    <div>
      <div className="checkBoxContainer">
        <label>
          <input type="checkbox" name="dnd" checked={checkedState.dnd} onChange={handleCheckboxChange} />
          DND
        </label>
        <label>
          <input
            type="checkbox"
            name="wrongCustomer"
            checked={checkedState.wrongCustomer}
            onChange={handleCheckboxChange}
          />
          Wrong Customers
        </label>
      </div>
      <div className="ReportContainer">
        {isLoading ? (
          <Loading />
        ) : !formData?.length ? (
          <p className="DataNotAvailable">Data not Available</p>
        ) : (
          <>
            {loading || (processDataLoading && <div className="loader-line-div" />)}
            <LoadTable title={Key} data={formData} loading={loading} error={error} />
          </>
        )}
      </div>
    </div>
  );
};
export default LaneAdded;
